import type { QueryClient } from "@tanstack/react-query"
import { showAccessDeniedPopup } from "@/entities/bottom-popup"
import { userKeys } from "@/entities/user"
import { onAccessDenied } from "@/shared/api/access-denied"

export function registerAccessDeniedHandler(
	queryClient: QueryClient,
): () => void {
	return onAccessDenied((error) => {
		showAccessDeniedPopup(
			{ code: error.code, permission: error.permission },
			null,
		)
		queryClient.invalidateQueries({ queryKey: userKeys.all })
	})
}
